import { Capacitor, WebPlugin, registerPlugin } from '@capacitor/core';

class NativeCompassWeb extends WebPlugin {
  async start() {
    return {
      available: false,
      active: false,
      permissionState: 'unavailable',
      accuracyLevel: 'unknown',
      accuracyScore: null,
      nativeAccuracy: null,
      nativeAccuracyUnit: null,
      platform: 'web',
      heading: null,
      magneticHeading: null,
      trueHeading: null,
    };
  }

  async stop() {
    return { active: false };
  }

  async getStatus() {
    return this.start();
  }
}

export const NativeCompass = registerPlugin('NativeCompass', {
  web: async () => new NativeCompassWeb(),
});

export function isNativeCompassPlatform() {
  return Capacitor.isNativePlatform() && ['android', 'ios'].includes(Capacitor.getPlatform());
}

export function nativeAccuracyRequiresCalibration(level) {
  return ['uncalibrated', 'unreliable', 'low'].includes(level);
}

export function nativeAccuracyLabel(level) {
  switch (level) {
    case 'high':
      return 'Excellente';
    case 'medium':
      return 'Correcte';
    case 'low':
      return 'Faible';
    case 'unreliable':
      return 'Instable';
    case 'uncalibrated':
      return 'Non calibree';
    default:
      return 'Inconnue';
  }
}